<template>
  <v-container v-if="user">
    <AppMenu></AppMenu>
    <v-app-bar elevation="5" color="#FFFFFF" fixed app clipped-left flat>
      <v-img :src="logo" max-width="100" contain position="center center" />
      <v-tabs v-if="!user" centered class="ml-n9 mr-16" color="grey darken-1">
        <v-tab
          v-for="tab in this.publicTabs"
          :key="tab.id"
          :to="tab.route"
          exact
        >
          <v-icon class="tab-logo">{{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <Notification v-if="user" :currentUser="user"></Notification>
    </v-app-bar>
  </v-container>
</template>

<script>
import logo from '../../assets/manushare.png'
import { mapState, mapActions, mapGetters } from 'vuex'
import AppMenu from './AppMenu'
import Notification from './Notification/Notification.vue'

export default {
	name: 'AppBar',
	props: {},
	components: { Notification, AppMenu },
	data: () => ({
		logo,
		publicTabs: [
			{ id: 1, name: 'Start', route: '/', icon: 'mdi-home' },
			{
				id: 2,
				name: 'Registrierung',
				route: '/register',
				icon: 'mdi-auth-plus'
			},
			{ id: 3, name: 'Über', route: '/about', icon: 'mdi-information-outline' }
		]
	}),
	computed: {
		...mapState('auth', ['user'])
	},
	methods: {
		...mapGetters('auth', ['isLogged']),
		...mapActions('auth', ['logout'])
	}
}
</script>

<style scoped>
.tab-logo {
  margin-right: 5px;
}

.v-avatar {
  margin: auto;
}
</style>
